import React from "react";

import styles from "pages/Welcome/style.module.scss";

/**
 * GenAI narratives use lightweight emphasis:
 * - **bold**
 * - "key phrase" (guest-voice / positioning — quotes stripped in UI)
 * Combined forms **"phrase"** / "**phrase**" render as one highlighted strong.
 */
const GENAI_INLINE_TOKEN_RE =
  /\*\*"([^"]+)"\*\*|"\*\*([^"]+)\*\*"|(\*\*(.+?)\*\*)|"([^"]+)"/g;

/**
 * Renders inline only — no block markdown, links, or HTML passthrough.
 */
export function renderWelcomeGenaiInlineMarkdown(text) {
  if (text == null || text === "") return text;
  const source = String(text);
  const nodes = [];
  let lastIndex = 0;
  let match;
  let key = 0;

  GENAI_INLINE_TOKEN_RE.lastIndex = 0;
  while ((match = GENAI_INLINE_TOKEN_RE.exec(source)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(source.slice(lastIndex, match.index));
    }

    const boldQuoted = match[1] ?? match[2];
    const boldOnly = match[4];
    const quotedOnly = match[5];

    if (boldQuoted != null) {
      nodes.push(
        <strong key={`welcome-genai-em-${key++}`} className={styles.genaiPhrase}>
          {boldQuoted}
        </strong>,
      );
    } else if (boldOnly != null) {
      nodes.push(
        <strong key={`welcome-genai-em-${key++}`}>{boldOnly}</strong>,
      );
    } else if (quotedOnly != null) {
      nodes.push(
        <span key={`welcome-genai-em-${key++}`} className={styles.genaiPhrase}>
          {quotedOnly}
        </span>,
      );
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < source.length) {
    nodes.push(source.slice(lastIndex));
  }
  if (nodes.length === 0) {
    return source;
  }
  if (nodes.length === 1 && typeof nodes[0] === "string") {
    return nodes[0];
  }
  return nodes;
}
